import { InfoCircleOutlined } from '@ant-design/icons'
import { Card, Tooltip } from 'antd'
import { CardProps } from 'antd/es/card'
import * as React from 'react'

import { KTitle } from './KTitle'

interface Props extends CardProps {
  title?: React.ReactNode
  titleTag?: keyof JSX.IntrinsicElements
  className?: string
  infoText?: string | React.ReactNode
  bodyPadding?: number
}

const KCard: React.FC<Props> = ({
  bordered = true,
  children,
  hoverable,
  title,
  titleTag = 'h2',
  infoText,
  className = '',
  bodyPadding,
  ...others
}) => {
  return (
    <Card
      bordered={bordered}
      hoverable={hoverable}
      bodyStyle={{ padding: bodyPadding }}
      title={
        <KTitle tag={titleTag} className="mb-0 white-space-normal">
          {title}
        </KTitle>
      }
      className={`custom-card-wrapper ${className} ${title ? 'has-title' : ''}`}
      {...others}>
      {children}
      {infoText && (
        <Tooltip placement="leftTop" title={infoText}>
          <InfoCircleOutlined className="info-icon" />
        </Tooltip>
      )}
    </Card>
  )
}

export default KCard
